import repository from './repository'

const resource = 'users/herica'

export default {
  index (params) {
    return repository.get(resource, { params })
  },
  store (data) {
    return repository.post(resource, data)
  },
  update (id, data) {
    return repository.put(`${resource}/${id}/edit`, data)
  },
  resetPassword (id) {
    return repository.put(`${resource}/${id}/reset-password`)
  },
}
